import type { IFilter } from "../api/models";

// PORT OF THE `/players` PAGE'S FILTER BUILDING: THE NAME SEARCH IN
// `players.component.ts` AND THE PLAYER-HOST CARD OF `advanced-filters`
// (`createFilters` WITH `showFilterPlayerOnly`). THE CLAUSES ARE BYTE-FOR-BYTE
// WHAT ANGULAR SENDS, ODDITIES INCLUDED, BECAUSE THE SERVER PARSES THESE SHAPES.

// ANGULAR PUSHES THE TEXT VERBATIM - NO TRIM, AND `%`/`_` ARE NOT ESCAPED
export function buildNameSearch(text: string): IFilter[] {
  if (!text) return [];
  return [{ field: "name", value: `%${text}%`, valueDataType: "string", type: "ILIKE", condition: "AND" }];
}

export type HostFilter = { kind: "hosts"; hostIds: number[] } | { kind: "unhosted" };

export function buildHostFilter(filter: HostFilter): IFilter[] {
  if (filter.kind === "unhosted") {
    // `condition` IS NULL BECAUSE IT IS THE FIRST CLAUSE (`advanced-filters.component.ts`)
    return [{ field: "host_id", value: "", valueDataType: "number", type: "IS NULL", condition: null }];
  }
  if (filter.hostIds.length === 0) return [];
  // ONE CLAUSE FOR ANY NUMBER OF HOSTS: A COMMA-JOINED VALUE WITH `=`, AND
  // `condition: "OR"` EVEN THOUGH IT IS THE ONLY CLAUSE
  return [{ field: "host_id", value: filter.hostIds.join(","), valueDataType: "number", type: "=", condition: "OR" }];
}

// THE TWO SORT KEYS THE PAGE OFFERS, AS THE API NAMES THEM
export const PLAYER_SORTS = [
  { id: "name", label: "Player" },
  { id: "host_name", label: "Host" },
] as const;

export type PlayerSort = (typeof PLAYER_SORTS)[number]["id"];

// PAGE SIZE IS FIXED AT 20 ON THE ANGULAR PAGE, WITH NO PICKER
export const PLAYERS_PAGE_SIZE = 20;
